import React, { useMemo, useState } from 'react';
import Modal from '../common/Modal';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT, formatDate } from '../../utils/format';

const TYPES = {
  1: { name: 'Investment',    klass: 'invest',   icon: '↑' },
  2: { name: 'Trading Profit',klass: 'roi',      icon: '%' },
  3: { name: 'Level Income',  klass: 'level',    icon: 'L' },
  4: { name: 'Claim',         klass: 'claim',    icon: '$' },
  5: { name: 'Start Trade',   klass: 'trade',    icon: '⚡' },
  6: { name: 'Migrated',      klass: 'migrated', icon: 'M' }
};

function Row({ a }) {
  const t = TYPES[a.activityType] || { name: 'Event', klass: 'invest', icon: '·' };
  return (
    <div className="activity-item">
      <div className={`icon ${t.klass}`}>{t.icon}</div>
      <div className="info">
        <div className="type">{t.name}</div>
        <div className="time">{formatDate(a.timestamp)}</div>
      </div>
      <div className="amt">{formatUSDT(a.amount)}</div>
    </div>
  );
}

const PAGE_SIZE = 10;

export default function RecentActivity() {
  const { activities = [] } = useContractState();
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);

  const recent5 = useMemo(() => activities.slice(0, 5), [activities]);

  const pageCount = Math.max(1, Math.ceil(activities.length / PAGE_SIZE));
  const start = page * PAGE_SIZE;
  const slice = activities.slice(start, start + PAGE_SIZE);

  return (
    <>
      <div className="recent-head">
        <h2>Recent History</h2>
        {activities.length > 0 && (
          <button className="link" onClick={() => { setPage(0); setOpen(true); }}>
            View all →
          </button>
        )}
      </div>
      {recent5.length === 0
        ? <div className="card" style={{ padding: 20, textAlign: 'center', color: 'var(--text-dim)' }}>No activity yet.</div>
        : recent5.map((a, i) => <Row key={`${a.timestamp}-${i}`} a={a} />)}

      <Modal open={open} onClose={() => setOpen(false)} title="Activity History" subtitle={`${activities.length} events`}>
        {slice.map((a, i) => <Row key={`m-${a.timestamp}-${i}`} a={a} />)}
        <div className="row-between mt-16">
          <button className="btn btn-ghost btn-sm" disabled={page === 0} onClick={() => setPage(p => Math.max(0, p - 1))}>← Prev</button>
          <span className="text-dim" style={{ fontSize: 12 }}>Page {page + 1} of {pageCount}</span>
          <button className="btn btn-ghost btn-sm" disabled={page >= pageCount - 1} onClick={() => setPage(p => Math.min(pageCount - 1, p + 1))}>Next →</button>
        </div>
      </Modal>
    </>
  );
}
